import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { consent, defaultValues, salutations } from "services"
import RendezVous from "../components/RendezVous"
import Programmes from "../components/Programmes"
import useLandingPage from "../services/useLandingPage"
import { academicLevelsPostBac, LAST_FORMS, PHONE_CALL } from "../services/landingPages"

// LP Post-bac Parcoursup : PGE / BMI, campus de Paris uniquement
const Form = () => {
  const methods = useForm({
    defaultValues: {
      ...consent,
      rendezVous: PHONE_CALL,
      lead: {
        ...defaultValues,
        Campus__c: 'Paris',
        Salutation: '',
        PGE__c: false,
        BMI__c: false
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  const { submit } = useLandingPage({
    campaignStatus: 'Contact Requested',
    formId: 'CONTACT',
    lastForm: LAST_FORMS.postBacParcoursup,
    leadSource: 'LP : Demande de contact',
    urlKey: 'ISG-LP-POST-BAC-PSUP'
  })

  const onSubmit = data => submit({ ...data, campusLabel: 'Paris' })

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <RendezVous campusLabel="le campus de Paris" />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={academicLevelsPostBac} section={false} specialites={false} />
        <Programmes programmes={[
          { name: 'lead.PGE__c', label: <strong>Programme Grande École en 5 ans.</strong> },
          { name: 'lead.BMI__c', label: <strong>Bachelor en management international.</strong> }
        ]} />
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit label="Envoyer" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISG France" />
      </Grid>
    </FormProvider>
  )
}

export default Form
